import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyAr53vGzhbpYucEQK91OwEbrG-B3dw_XVg',
  authDomain: 'pharmdev-1d19d.firebaseapp.com',
  databaseURL: 'https://pharmdev-1d19d-default-rtdb.firebaseio.com',
  projectId: 'pharmdev-1d19d',
  storageBucket: 'pharmdev-1d19d.firebasestorage.app',
  messagingSenderId: '138004431790',
  appId: '1:138004431790:web:de793244957923749bbe3f',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getDatabase(app);

// Secondary app instance used only for creating new admin users — creating a
// user on the primary `auth` instance signs the browser in as that new user,
// which would log out the superadmin performing the action.
const secondaryApp = initializeApp(firebaseConfig, 'Secondary');
export const secondaryAuth = getAuth(secondaryApp);